import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import './Detail.css'
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faExternalLinkAlt, faStar, faHeart } from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import baseURL from '../url';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import moneda from '../moneda';

export default function Detail() {
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    SwiperCore.use([Navigation, Pagination, Autoplay]);
    const { idProducto } = useParams();
    const [producto, setProducto] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [cantidad, setCantidad] = useState(1);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [contactos, setContactos] = useState([]);
    const [favoritos, setFavoritos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const location = useLocation();

    // Extrae item1-item10 que no estén vacíos
    const items = producto? [
        producto.item1, producto.item2, producto.item3, producto.item4, producto.item5,
        producto.item6, producto.item7, producto.item8, producto.item9, producto.item10
    ].filter(item => item && item.trim()!== '') : [];

    const itemSeleccionado = items[selectedItemIndex] || '';

    useEffect(() => {
        cargarProductos();
        cargarContacto();
        cargarFavoritos();
        cargarCategoria();
    }, []);

    useEffect(() => {
        if (items.length > 0) {
            setSelectedItemIndex(0);
        }
    }, [producto]);

    // NUEVO: Calcula cantidad total de este producto en el carrito
    const getCantidadEnCarrito = () => {
        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        return cart
           .filter(item => item.idProducto === parseInt(idProducto))
           .reduce((total, item) => total + item.cantidad, 0);
    };

    // NUEVO: Precio actual según mayoreo
    const getPrecioActual = () => {
        if (!producto) return 0;
        const cantidadTotal = getCantidadEnCarrito() + cantidad;
        const esMayoreo = cantidadTotal >= 6 && producto.precioAnterior > 0;
        return esMayoreo? producto.precioAnterior : producto.precio;
    };

    // NUEVO: Verifica si aplica mayoreo
    const esMayoreo = () => {
        if (!producto) return false;
        const cantidadTotal = getCantidadEnCarrito() + cantidad;
        return cantidadTotal >= 6 && producto.precioAnterior > 0;
    };

    const handleSelectionChange = (index) => {
        setSelectedItemIndex(index);
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`)
           .then(response => response.json())
           .then(data => {
                setCategorias(data.categorias || []);
            })
           .catch(error => console.error('Error al cargar categorias:', error));
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`)
           .then(response => response.json())
           .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
           .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`)
           .then(response => response.json())
           .then(data => {
                setProductos(data.productos || []);
                setLoading(false);
            })
           .catch(error => {
                console.error('Error al cargar productos:', error)
                setLoading(true);
            });
    };

    const cargarFavoritos = () => {
        const storedFavoritos = JSON.parse(localStorage.getItem('favoritos')) || [];
        setFavoritos(storedFavoritos);
    };

    useEffect(() => {
        const product = productos.find((e) => e.idProducto === parseInt(idProducto));
        setProducto(product);
    }, [idProducto, productos]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function handleCompartirClick() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este producto',
                url: window.location.href,
            })
               .then(() => console.log('Contenido compartido correctamente'))
               .catch((error) => console.error('Error al compartir:', error));
        } else {
            console.error('La API de compartir no está disponible en este navegador.');
        }
    }

    const handleWhatsappMessage = () => {
        const phoneNumber = contactos?.telefono;
        const title = encodeURIComponent(producto?.titulo?.replace(/\s+/g, '-'));
        const precioActual = getPrecioActual();
        const formattedPrice = Number(precioActual).toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        const variante = itemSeleccionado? `\nVariante: ${itemSeleccionado}` : '';
        const message = `Hola 🌟, quisiera más información sobre\n\n✅ *${producto?.titulo}*${variante}\nCantidad: ${cantidad}\nPrecio: ${moneda} ${formattedPrice} ${esMayoreo()? '(Mayoreo)' : ''}`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    const goBack = () => {
        if (location.key!== 'default') {
            navigate(-1);
        } else {
            navigate('/');
        }
    };

    // CORREGIDO: Ahora usa cartId único por variante



    const addToCart = () => {
        if (!producto) return;

        if (producto.stock < 1) {
            toast.error('No hay stock', { autoClose: 400 });
            return;
        }

        const itemsDisponibles = [
            producto.item1, producto.item2, producto.item3, producto.item4, producto.item5,
            producto.item6, producto.item7, producto.item8, producto.item9, producto.item10
        ].filter(item => item && item.trim()!== '');

        const itemSeleccionado = itemsDisponibles[selectedItemIndex];

        if (itemsDisponibles.length > 0 &&!itemSeleccionado) {
            toast.error('Selecciona una opción', { autoClose: 400 });
            return;
        }

        const cart = JSON.parse(localStorage.getItem('cart')) || [];

        // CLAVE 1: cartId único por variante
        const cartId = itemsDisponibles.length > 0
        ? `${producto.idProducto}-${itemSeleccionado}`
            : `${producto.idProducto}-unico`;

        // CLAVE 2: Busca por cartId, NO por idProducto
        const existingItemIndex = cart.findIndex(item => item.cartId === cartId);

        if (existingItemIndex!== -1) {
            cart[existingItemIndex].cantidad += cantidad;
            toast.success(`+${cantidad} ${producto.titulo} ${itemSeleccionado}`, { autoClose: 400 });
        } else {
            cart.push({
                idProducto: producto.idProducto,
                cantidad: cantidad,
                item: itemsDisponibles.length > 0? [itemSeleccionado] : [], // CLAVE 3: Solo 1 item
                cartId: cartId // CLAVE 4: Guarda el cartId
            });
            toast.success(`${producto.titulo} ${itemSeleccionado} agregado`, { autoClose: 400 });
        }

        localStorage.setItem('cart', JSON.stringify(cart));
        window.dispatchEvent(new Event('storage'));
        setCantidad(1);
    };    




    const incrementCantidad = () => {
        setCantidad(cantidad + 1);
    };

    const decrementCantidad = () => {
        if (cantidad > 1) {
            setCantidad(cantidad - 1);
        }
    };

    const agregarAFavoritos = (idProducto) => {
        const favList = [...favoritos];
        const index = favList.indexOf(idProducto);
        if (index === -1) {
            favList.push(idProducto);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
            toast.success('Agregado a favoritos');
        } else {
            favList.splice(index, 1);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
            toast.info('Eliminado de favoritos');
        }
    };

    if (!producto) {
        return <DetailLoading />;
    }

    return (
        <div className="detail">
            <ToastContainer />
            <div className="deFlexDetail">
                <button className="back" onClick={goBack}> <FontAwesomeIcon icon={faArrowLeft} /> </button>
                <div className="deFLexIcon">
                    <button onClick={() => agregarAFavoritos(producto.idProducto)} className='favoritos-btn'>
                        <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(producto.idProducto)? 'red' : 'gray' }} />
                    </button>
                    <button className="share" onClick={handleCompartirClick}> <FontAwesomeIcon icon={faExternalLinkAlt} /> </button>
                </div>
            </div>
            <div className="detail-contain">
                <SwiperSlide id={"swiperDetail"}>
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        loop={true}
                        slidesPerView={'auto'}
                        coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                        autoplay={{ delay: 3000 }}
                        pagination={{ clickable: true }}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                    >
                        {producto.imagen1 && (
                            <SwiperSlide>
                                <img
                                    src={producto.imagen1}
                                    alt={producto.titulo}
                                    className="imagen1"
                                    onClick={() => {
                                        setModalImage(producto.imagen1);
                                        setIsModalOpen(true);
                                    }}
                                />
                            </SwiperSlide>
                        )}
                        {producto.imagen2 && (
                            <SwiperSlide>
                                <img
                                    src={producto.imagen2}
                                    alt={producto.titulo}
                                    className="imagen2"
                                    onClick={() => {
                                        setModalImage(producto.imagen2);
                                        setIsModalOpen(true);
                                    }}
                                />
                            </SwiperSlide>
                        )}
                        {producto.imagen3 && (
                            <SwiperSlide>
                                <img
                                    src={producto.imagen3}
                                    alt={producto.titulo}
                                    className="img"
                                    onClick={() => {
                                        setModalImage(producto.imagen3);
                                        setIsModalOpen(true);
                                    }}
                                />
                            </SwiperSlide>
                        )}
                        {producto.imagen4 && (
                            <SwiperSlide>
                                <img
                                    src={producto.imagen4}
                                    alt={producto.titulo}
                                    className="imagen4"
                                    onClick={() => {
                                        setModalImage(producto.imagen4);
                                        setIsModalOpen(true);
                                    }}
                                />
                            </SwiperSlide>
                        )}
                    </Swiper>
                </SwiperSlide>
                <div className="textDetail">
                    <h2 className="title">{producto.titulo}</h2>
                    <hr />
                    <div className="deFLexBuet">
                        {categorias
                           .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                           .map(categoriaFiltrada => (
                                <h4 key={categoriaFiltrada.idCategoria}>
                                    <FontAwesomeIcon icon={faStar} />{categoriaFiltrada.categoria}
                                </h4>
                            ))
                        }
                        {producto.stock >= 1? (
                            <h4 style={{ color: 'green', backgroundColor: '#ccffcc', padding: '0px 10px', borderRadius: '6px' }}>
                                Stock {producto.stock}
                            </h4>
                        ) : (
                            <h4 style={{ color: 'red', backgroundColor: '#ffc1c1', padding: '0px 10px', borderRadius: '6px' }}>
                                Agotado
                            </h4>
                        )}
                    </div>

                    {/* PRECIO CORREGIDO CON MAYOREO */}
                    <div className='deFLexPrice'>
                        <h5 className="price">
                            {moneda} {getPrecioActual()?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                            {esMayoreo() && <span className='tagMayoreo'> Mayoreo</span>}
                        </h5>
                        {esMayoreo() && (
                            <h5 className='precioTachadoDetail'>
                                {moneda} {producto?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                            </h5>
                        )}
                    </div>

                    <p>{producto.descripcion}</p>
                    
                    {/* VARIANTES/ITEMS */}
                    <div className='itemsDetail'>
                        {items.map((item, index) => (
                            <label key={index}>
                                <input
                                    type="radio"
                                    name="talle"
                                    value={item}
                                    checked={selectedItemIndex === index}
                                    onChange={() => handleSelectionChange(index)}
                                />
                                {item}
                            </label>
                        ))}
                    </div>

                    <div className='deFlexCart'>
                        <button onClick={decrementCantidad}>-</button>
                        <span>{cantidad}</span>
                        <button onClick={incrementCantidad}>+</button>
                    </div>
                    <div className='deFlexGoTocart'>
                        <button onClick={addToCart} className='btnAdd'>
                            Agregar <FontAwesomeIcon icon={faShoppingCart} />
                        </button>
                        <button className="wpp" onClick={handleWhatsappMessage}>
                            WhatsApp
                            <img src={whatsappIcon} alt="whatsappIcon" />
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                center
                classNames={{ modal: 'custom-modal' }}
            >
                <img src={modalImage} alt={producto.titulo} />
            </Modal>
        </div>
    )
}